module.exports = __webpack_public_path__ + "helveticaneue_medium.8e54936e6631b2f5e236.woff2";


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/landing_page/src/assets/fonts/helveticaneue_medium.woff2
// module id = ../../../../../src/assets/fonts/helveticaneue_medium.woff2
// module chunks = styles